import { render, staticRenderFns } from "./multipleMerchant.vue?vue&type=template&id=4db384fa"
import script from "./multipleMerchant.vue?vue&type=script&lang=js"
export * from "./multipleMerchant.vue?vue&type=script&lang=js"
import style0 from "./multipleMerchant.vue?vue&type=style&index=0&id=4db384fa&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db384fa')) {
      api.createRecord('4db384fa', component.options)
    } else {
      api.reload('4db384fa', component.options)
    }
    module.hot.accept("./multipleMerchant.vue?vue&type=template&id=4db384fa", function () {
      api.rerender('4db384fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/package/multipleMerchant.vue"
export default component.exports